import type { SVGProps } from 'react';

export const Danger = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.41911 1.94989C7.10119 0.698506 8.89815 0.698506 9.58024 1.94989L15.7824 13.3288C16.436 14.5282 15.5682 15.9898 14.2023 15.9899H1.79801C0.432065 15.9899 -0.436499 14.5282 0.216958 13.3288L6.41911 1.94989ZM8 5.18921C7.50294 5.18921 7.09961 5.59254 7.09961 6.0896V9.49194C7.09961 9.989 7.50294 10.3923 8 10.3923C8.49692 10.3922 8.89941 9.9889 8.89941 9.49194V6.0896C8.89941 5.59265 8.49692 5.18937 8 5.18921ZM8 12.1921C7.50294 12.1921 7.09961 12.5955 7.09961 13.0925C7.09971 13.5895 7.50301 13.9919 8 13.9919C8.49685 13.9918 8.89931 13.5894 8.89941 13.0925C8.89941 12.5956 8.49692 12.1923 8 12.1921Z"
        fill="currentColor"
      />
    </svg>
  );
};
